import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { SsrReplaceService } from 'avn/guards/ssr-replace.service';

import { AuthAppService } from './auth-app/auth-app.service';

@Injectable({
  providedIn: 'root'
})
export class Auth0UiService {
  constructor(
    private auth: AuthService,
    private router: Router,
    private ssr: SsrReplaceService,
    private authApp: AuthAppService
  ) {}

  private static readonly key_frontend = 'TRINITY_JWT_KEY';
  private static readonly key_backend = 'TRINITY_JWT_KEY_BACKEND';

  loginCheck(path?: string): void {
    if (this.authApp.clientType() === 'frontend') {
      this.auth.idTokenClaims$.subscribe((id: any) => {
        if (id?.__raw) {
          console.info('', id);
          this.setAuth(id.__raw);
          this.setTrinityLoggedUser(id);

          const url_redirect_mode = localStorage.getItem('url_redirect_mode');
          if (url_redirect_mode) {
            localStorage.removeItem('url_redirect_mode');
            this.router.navigate([url_redirect_mode]);
          }

          if (path) {
            localStorage.setItem('current_path', path);
          }
        }
      });

      this.auth.isAuthenticated$.subscribe((au: any) => {
        if (!au) {
          this.auth.loginWithRedirect();
        }
      });
    }
  }

  signOut(): void {
    localStorage.clear();
    this.auth.logout({ logoutParams: { returnTo: this.ssr.getLocation().origin + '/' } });
  }

  setAuth(token: string): void {
    localStorage.setItem('TRINITY_JWT_KEY', token);
  }

  setTrinityLoggedUser(user: any): void {
    localStorage.setItem('ClientType', 'frontend');
    localStorage.setItem('trinityLoggedUser', JSON.stringify(user));
    localStorage.setItem('trinityLastLogin', new Date().toString());
  }
}
